 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","1":"commons","2":"c8d1367789ad508e06def6f11af11ec22f7862e6","3":"61a9c66cffb8d38b8bf09e5214111eb29e72c99b","4":"cba628da0834c1417cca889b114e60ae1c98a5fb","5":"d800bdaa33d7609f384add2ab22eb8ac0852b412","6":"630cca4dd7324c5b8c52e3abe5398313de036033","7":"83c5604ee3f6663caa26b8ebf896114392f5ed94","11":"component---packages-blog-core-src-templates-collection-author-js","12":"component---packages-blog-core-src-templates-collection-category-js","13":"component---packages-blog-core-src-templates-collection-tag-js","14":"component---packages-blog-core-src-templates-post-js","15":"component---packages-blog-core-src-templates-posts-js","16":"component---packages-blog-pages-src-pages-404-jsx","17":"component---packages-blog-pages-src-pages-acs-24-jsx","18":"component---packages-blog-pages-src-pages-acs-25-jsx","19":"component---packages-blog-pages-src-pages-acspro-jsx","20":"component---packages-blog-pages-src-pages-authors-jsx","21":"component---packages-blog-pages-src-pages-bgs-jsx","22":"component---packages-blog-pages-src-pages-contact-2-jsx","23":"component---packages-blog-pages-src-pages-contact-jsx","24":"component---packages-blog-pages-src-pages-faculty-jsx","25":"component---packages-blog-pages-src-pages-focus-jsx","26":"component---packages-blog-pages-src-pages-kurs-23-jsx","27":"component---packages-blog-pages-src-pages-live-jsx","28":"component---packages-blog-pages-src-pages-login-jsx","29":"component---packages-blog-pages-src-pages-onkayit-jsx","30":"component---packages-blog-pages-src-pages-plus-jsx","31":"component---packages-blog-pages-src-pages-profile-jsx","32":"component---packages-blog-pages-src-pages-register-jsx","33":"component---packages-blog-pages-src-pages-terms-jsx","34":"component---packages-blog-pages-src-pages-verify-email-jsx","35":"component---packages-blog-pages-src-pages-verify-phone-jsx"}[chunkId]||chunkId) + "-" + {"0":"0ec71dd62c66cb95665c","1":"07540c2e5790bf927da1","2":"6d0584dd21c65ac1e16d","3":"3d42cc24344c1ec2fc73","4":"0a05f18dc57ca1775953","5":"7f28d3577e124bf91e32","6":"05a33802cf4336be968c","7":"5c76e84dd6477d720f4b","11":"1dee16b0274c32ed770a","12":"e852c2ad4db68e415096","13":"9e3a79257e0bffb51e16","14":"35e7539a318a7bb3d4aa","15":"0f4b225056429abd8d34","16":"d44a6312ad475527be7a","17":"4f6d5ef01883dabb339d","18":"dba94ee29da4dd474091","19":"a25221b410b09c43684e","20":"156113fc9a4bd950b13c","21":"a0b8e6ebf5ccc6d08274","22":"55b8432a27d9b0657a53","23":"08d9a3f962bf28dc6d3d","24":"0d283a85bcc75b0e875a","25":"ab33563b3a41d5153c74","26":"57813c737c9ce763f3fe","27":"962e45fc736bc085a383","28":"b94e259a1f286cd9880f","29":"a14b4ef0253cca829251","30":"2f5b53b05fb23f222383","31":"07bdf50ea8da4f0d0be4","32":"d70bd31ec27a2a951c37","33":"edead0fc06c7a96edf49","34":"0afda49c62ea25956f3e","35":"40bd15cd325f74675597","40":"5649866e667f8f361f21","41":"3a50297604ad1c9e254b","42":"fa763e33d16f39329083","43":"c84c51f723374bfa3531","44":"2b42bd0f4e0434620599","45":"1980d72fd7ecee1b71ab","46":"ad4ce845922c338177d2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","1":"commons","2":"c8d1367789ad508e06def6f11af11ec22f7862e6","3":"61a9c66cffb8d38b8bf09e5214111eb29e72c99b","4":"cba628da0834c1417cca889b114e60ae1c98a5fb","5":"d800bdaa33d7609f384add2ab22eb8ac0852b412","6":"630cca4dd7324c5b8c52e3abe5398313de036033","7":"83c5604ee3f6663caa26b8ebf896114392f5ed94","11":"component---packages-blog-core-src-templates-collection-author-js","12":"component---packages-blog-core-src-templates-collection-category-js","13":"component---packages-blog-core-src-templates-collection-tag-js","14":"component---packages-blog-core-src-templates-post-js","15":"component---packages-blog-core-src-templates-posts-js","16":"component---packages-blog-pages-src-pages-404-jsx","17":"component---packages-blog-pages-src-pages-acs-24-jsx","18":"component---packages-blog-pages-src-pages-acs-25-jsx","19":"component---packages-blog-pages-src-pages-acspro-jsx","20":"component---packages-blog-pages-src-pages-authors-jsx","21":"component---packages-blog-pages-src-pages-bgs-jsx","22":"component---packages-blog-pages-src-pages-contact-2-jsx","23":"component---packages-blog-pages-src-pages-contact-jsx","24":"component---packages-blog-pages-src-pages-faculty-jsx","25":"component---packages-blog-pages-src-pages-focus-jsx","26":"component---packages-blog-pages-src-pages-kurs-23-jsx","27":"component---packages-blog-pages-src-pages-live-jsx","28":"component---packages-blog-pages-src-pages-login-jsx","29":"component---packages-blog-pages-src-pages-onkayit-jsx","30":"component---packages-blog-pages-src-pages-plus-jsx","31":"component---packages-blog-pages-src-pages-profile-jsx","32":"component---packages-blog-pages-src-pages-register-jsx","33":"component---packages-blog-pages-src-pages-terms-jsx","34":"component---packages-blog-pages-src-pages-verify-email-jsx","35":"component---packages-blog-pages-src-pages-verify-phone-jsx"}[chunkId]||chunkId) + "." + {"0":"1240ae08d8bf6237e310","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","42":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
